import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SetupAtivacaoService {
  private apiServerUrl = environment.loganConfig.url;

  headers = new HttpHeaders().set('Content-Type', 'text/plain; charset=utf-8');
  requestOptions: Object = {
    headers: this.headers,
    responseType: 'text',
    withCredentials: true,
  };

  constructor(private http: HttpClient) {}

  public setupAtivacao(serial: string[]) {
    return this.http.post<any>(
      `${this.apiServerUrl}/api/v1/setupAtivacao`,
      { serial },
      this.requestOptions
    );
  }
}
